"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  slides: 'coolest,fastest,easiest',
  intervalProp: '1500',
  delayProp: '0',
  adjustingSpeedProp: '150',
  fade: true,
  mask: false,
  noWrap: true
};
exports["default"] = _default;